import { render, staticRenderFns } from "./TurtleItem.vue?vue&type=template&id=736c3307&"
import script from "./TurtleItem.vue?vue&type=script&lang=js&"
export * from "./TurtleItem.vue?vue&type=script&lang=js&"
import style0 from "./TurtleItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TurtleItem.vue"
export default component.exports